import React, { useEffect, useState, useCallback, useContext } from 'react'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import { Box, Divider, Drawer, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip, styled, useMediaQuery } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import "../homepage.css"
import { BtnSearch } from 'components/Button/ButtonAll';
import { ApiNavigation, ApiNavigationType } from 'enum/api';
import { FnAxios, FnDialog, I18n, RouterDOM, SecureStorage } from 'utilities/utilities';
import { IMenuItem } from 'components/Layout/Menu/Layout1/MenuProps';
import AvatarIcon from 'components/Layout/components/Avatar';
import { GetUserAccout } from 'utilities/SystemFunction';
import LoginCenter from 'view/Authen/LoginCenter';
import { AiOutlineLock } from "react-icons/ai";
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { ProviderLayout } from '../Homepage';
import BoxTextSize from 'components/Layout/BoxTextSize';
import MenuBarHome from '.';
import LogoutIcon from '@mui/icons-material/Logout';
interface IPropsAppbar {
    window?: () => Window;
}

const HideAppBar = (props: IPropsAppbar) => {
    const { window } = props;

    const Router = RouterDOM();
    const DialogFn = FnDialog();
    const navigate = useNavigate();
    const AxiosFn = FnAxios();

    const [isUser, setisUser] = useState<any>(false);
    const objUser: IAvatar = GetUserAccout();
    const [arrDataMenu, setarrDataMenu] = useState<IMenuItem[]>([]);
    const [isLogin, setisLogin] = useState<any>(false);
    const [open, setOpen] = React.useState(false);
    const Layout630 = useMediaQuery('(min-width:630px)');
    const Layout900 = useMediaQuery('(min-width:900px)');
    const [IsMenuOpen, setIsMenuOpen] = React.useState(Layout900)
    const [IsOverMouse, setIsOverMouse] = React.useState(false)
    const [arrMenuOpen, setarrMenuOpen] = React.useState([])

    // const isWeb = useMediaQuery('(min-width:768px)');
    const LayoutWeb = useMediaQuery('(min-width:1180px)');

    //บางเมนูเค้าตัดออกแล้ว เหลือแค่ 3 เมนูนี้จ้า
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
    });

    const handleClickMenuOpen = React.useCallback((menuID: number) => {
        const selectedIndex = arrMenuOpen.indexOf(menuID);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(arrMenuOpen, menuID);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(arrMenuOpen.slice(1));
        } else if (selectedIndex === arrMenuOpen.length - 1) {
            newSelected = newSelected.concat(arrMenuOpen.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                arrMenuOpen.slice(0, selectedIndex),
                arrMenuOpen.slice(selectedIndex + 1),
            );
        }
        setarrMenuOpen(newSelected);
    }, [arrMenuOpen]);

    const CallLogin = useCallback(() => {
        return (
            <>
                {isLogin && <LoginCenter setisLogin={setisLogin} />}
            </>
        );
    }, [isLogin]);

    const getDataMenu = () => {
        //1 = FrontendTop, 2 = FrontendLeft, 3 = Backend
        let result: IMenuItem[] = [];
        AxiosFn.Get(ApiNavigation.GetMenu, { nMenuType: ApiNavigationType.FrontEndTop }, (d) => {
            result = d.objResult.lstMenu;
            setarrDataMenu([...result]);
        })
    };

    const onGotoPage = () => navigate("/searchsite");

    const objProvider = React.useMemo(() => (
        {
            IsMenuOpen,
            setIsMenuOpen,
            IsOverMouse,
            setIsOverMouse,
            arrMenuOpen,
            handleClickMenuOpen,
            isMouseOver: false,
            Layout630,
            Layout900,
            open,
            setOpen
        }
    ), [IsMenuOpen, IsOverMouse, Layout630, Layout900, arrMenuOpen, handleClickMenuOpen, open]);



    useEffect(() => {
        if (objUser) setisUser(objUser.nUserID != null);
    }, [objUser]);


    useEffect(() => {
        getDataMenu();
    }, []);

    React.useEffect(() => {
        if (IsMenuOpen && !Layout900) {
            setIsMenuOpen(false)
        }
    }, [Layout900])


    useEffect(() => {
        if (open) {
            setOpen(false)
        }
    }, [])

    const handleLogout = () => {
        DialogFn.Submit(I18n.SetText("msgConfirmLogout"), () => {
            DialogFn.CloseSubmit()
            // SecureStorage.Clear();
            SecureStorage.Remove(process.env.REACT_APP_JWT_KEY);
            Router.GoToPage("/Home")
        });
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <ProviderLayout.Provider
                value={objProvider}
            >
                <CallLogin />
                {
                    LayoutWeb ?
                        <AppbarWebSize
                            trigger={trigger}
                            onGotoPage={onGotoPage}
                            setisLogin={setisLogin}
                            isUser={isUser}
                            handleLogout={handleLogout}
                            CallLogin={CallLogin}
                            arrDataMenu={arrDataMenu}
                            Router={Router}
                        />
                        :
                        <AppbarMobileSize
                            trigger={trigger}
                            onGotoPage={onGotoPage}
                            setisLogin={setisLogin}
                            handleLogout={handleLogout}
                            isUser={isUser}
                            CallLogin={CallLogin}
                        />
                }
            </ProviderLayout.Provider>
        </React.Fragment >
    )
}
export default HideAppBar


const AppbarWebSize = ({ trigger, onGotoPage, isUser, setisLogin, handleLogout, CallLogin, arrDataMenu, Router }) => {
    return (
        <Slide appear={false} direction="down" in={!trigger} >
            <AppBar className='nav-bar'>
                {/* เปลี่ยนขนาดตัวอักษร */}
                <BoxTextSize isFrontEnd={true} />
                <Toolbar className='div-blur'>
                    <Grid container className='toolbar-home'>
                        <Grid item xs={'auto'}>
                            <Grid container spacing={1} justifyContent={"flex-start"} alignItems='center' >
                                <Grid item xs={'auto'}>
                                    <Link to="/Home" preventScrollReset={true}>
                                        <Box
                                            component="div"
                                            className="img-fe-logo"
                                        />
                                    </Link>
                                </Grid>
                                <Grid item xs={'auto'}>
                                    <Typography className='project-name-text'>
                                        กองทุนจัดการซากดึกดำบรรพ์
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item xs={'auto'}>
                            <ul style={{ margin: 0 }}>
                                {
                                    arrDataMenu.filter(w => w.nMenuType == 1).map(item => {
                                        let sRoute = Router.GetCurrentRoute();
                                        let sPathName = sRoute.replace("/", "");
                                        let sRouteName = item.sRoute.replace("/", "").toLocaleLowerCase();
                                        return (
                                            <Link
                                                key={item.sRoute}
                                                to={item.sRoute}
                                                preventScrollReset={true}
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <li key={item.sKey} className={((item.sRoute === "/Home" && sPathName === "") || (item.sRoute === "/Project" && sPathName === "projectfrom") || (item.sRoute === "/GalleryListImg" && sPathName === "gallerydetail") || sPathName === sRouteName) ? "div-MenuTopAction" : "div-MenuTop"}><Typography style={{ cursor: 'pointer', fontSize: '0.9rem', marginBottom: '0em', }} gutterBottom>{item.sMenuName}</Typography></li>
                                            </Link>
                                        )
                                    })
                                }
                                <li>
                                    <BtnSearch
                                        id='search-all'
                                        IsCircleWithOutText
                                        className='btc-search-all'
                                        onClick={() => { onGotoPage() }}
                                    />
                                </li>
                                {isUser
                                    ?
                                    <li><AvatarIcon isName={false} ></AvatarIcon></li>
                                    :
                                    <li style={{ width: '40px' }}>
                                        <div className='banner-btn-login' id="isLogin" onClick={() => { setisLogin(true); }}>
                                            <AiOutlineLock />
                                            <Divider orientation="vertical" flexItem className='banner-btn-login-divider' />
                                            <div className='banner-btn-login-text'>
                                                <Typography className='text-log'>
                                                    LOG
                                                </Typography>
                                                <Typography className='text-in'>
                                                    IN
                                                </Typography>
                                            </div>
                                        </div>
                                    </li>
                                }
                            </ul>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </Slide>
    )
}

const AppbarMobileSize = ({ trigger, onGotoPage, isUser, setisLogin, handleLogout, CallLogin }) => {
    const {

        open,
        setOpen
    } = useContext(ProviderLayout);

    return (
        <>
            <Slide appear={false} direction="down" in={!trigger}>
                <AppBar className={"div-glass"}>
                    <Toolbar style={{ width: '100%' }}>
                        <Grid container alignItems='center' justifyContent={"space-between"}>
                            <Grid item xs={'auto'}>
                                <Grid container spacing={1} justifyContent={"flex-start"} alignItems='center' >
                                    <Grid item xs={'auto'}>
                                        <IconButton
                                            aria-label="menu"
                                            edge="start"
                                            style={{ left: '10px' }}
                                            onClick={() => { setOpen(e => !e) }}
                                        >
                                            <MenuRoundedIcon className='MenuIcon' style={{ width: "35px", height: "30px" }} />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={'auto'}>
                                        <Link to="/Home" preventScrollReset={true}>
                                            <Box
                                                component="div"
                                                className="img-fe-logoPhone"
                                            />
                                        </Link>
                                    </Grid>
                                    <Grid item xs={'auto'}>
                                        <Typography className='project-name-text-glass'>
                                            กองทุนจัดการซากดึกดำบรรพ์
                                        </Typography>
                                    </Grid>
                                </Grid>

                            </Grid>
                            <Grid item xs={'auto'}>
                                <Grid container spacing={1} justifyContent={"flex-start"} alignItems='center' >
                                    <Grid item xs={'auto'}>
                                        <BtnSearch
                                            id='search-all'
                                            IsCircleWithOutText
                                            className='btc-search-all'
                                            onClick={() => { onGotoPage() }}
                                        />
                                    </Grid>
                                    <Grid item xs={'auto'}>
                                        {isUser
                                            ?
                                            <AvatarIcon isName={false} ></AvatarIcon>
                                            :
                                            <div id="isLogin" onClick={() => { setisLogin(true); }}>
                                                <Typography className='Login-text-phone'>
                                                    เข้าสู่ระบบ
                                                </Typography>
                                            </div>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </Slide>
            <Drawer
                anchor="left"
                open={open}
                onClose={() => { setOpen(e => !e) }}
            >
                <Grid container spacing={1} flexDirection={"column"} justifyContent={"space-between"} style={{ marginTop: '3px', height: '100vh' }}>
                    <Grid item>
                        <MenuBarHome />
                    </Grid>
                    <Grid item>
                        {isUser &&
                            <Tooltip title={"ออกจากระบบ"} placement="right">
                                <List disablePadding>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            className={`nav-menu-item nav-menu-item-lv1`}
                                            sx={{ pl: "16px", minWidth: '40px' }}
                                            onClick={handleLogout}
                                        >
                                            <ListItemIcon sx={{ ml: '2px' }}>
                                                <LogoutIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={"ออกจากระบบ"} primaryTypographyProps={{ style: { whiteSpace: "nowrap", overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                                        </ListItemButton>
                                    </ListItem>
                                </List>
                            </Tooltip>
                        }
                    </Grid>
                </Grid>
            </Drawer>
            {/* <CallLogin /> */}
        </>
    )
}



